import { Link } from 'react-router-dom';

export function Unauthorized() {
  return (
    <main
      style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <h1
        style={{
          fontFamily: 'var(--font-heading-active)',
          fontSize: '2rem',
          fontWeight: 700,
          color: 'var(--text)',
          marginBottom: '0.5rem',
        }}
      >
        Not authorized
      </h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: '1.5rem' }}>
        Your account doesn&rsquo;t have access to this area.
      </p>
      <Link to="/" style={{ color: 'var(--brand-primary)' }}>
        Go home
      </Link>
    </main>
  );
}
